/**
 * Construit une Url pour naviguer vers une autre application
 * (AGE, MOF, ...)
 *
 * @param appName application cible de l'url (i.e. age)
 * @param baseUri uri qui sera ajoutée en tant qu'url relative
 */
export function buildUrl(appName: string, baseUri?: string) {
    const regex = /^[^.]+(\..+\..+\..+)$/;
    let domain = '.dev.pc-scol.fr';
    const uri = baseUri ? baseUri : '';
    if (window.location.hostname.match(regex)) {
        domain = window.location.hostname.replace(regex, '$1');
    }
    const urlApiRequest = `https://${appName}${domain}${uri}`;
    return urlApiRequest;
}
